import NavDashboard from "@/components/dashboard/nav/nav";
import DashboardSidebar from "@/features/dashboard/nav/sidebar";
import Meta from "@/components/meta";
import { MaintenanceBanner, OfficeRelocationBanner } from "@/components/banner";

export default function DashboardLayout({ children }) {
  return (
    <>
      <Meta />
      <div>
        {/* Mobile */}
        <NavDashboard />

        <div className="flex">
          <div className="hidden lg:block">
            <DashboardSidebar />
          </div>
          <main className="min-h-screen bg-background-gray flex-grow min-w-0">
            {process.env.NEXT_PUBLIC_NOTIFY_UPCOMING_MAINTENANCE === "1" && (
              <MaintenanceBanner concise={true} />
            )}
            {process.env.NEXT_PUBLIC_NOTIFY_UPCOMING_RELOCATION === "1" && (
              <OfficeRelocationBanner concise={true} />
            )}
            {children}
          </main>
        </div>
      </div>
    </>
  );
}
